import 'react-table/react-table.css';
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {debounce} from 'throttle-debounce';
import moment from 'moment/min/moment-with-locales';
import PropTypes from 'prop-types';
import {fetchClaimsListPageData} from '../../../actions/claims/actionClaimsListPage';
import {IconEdit, PrimaryIcon} from '../../common/Button';
import {moduleRoles} from '../../../utils/roles';
import {editClaimsListButtonVisibility} from '../../../constants/claimsTicketRights';
import Table from '../../common/table/TicketTable';
import listMessages from '../../../intl/claims/listMessages';

class ListClaimsTable extends React.Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(props.location.search);
        const loadedState = this.loadStateFromSessionStorage({
            listCLDefaultPageSize: 10,
            listCLDefaultSort: [{id: 'TICKET_NUMBER', desc: true}],
            listCLDefaultFilters: [],
        });

        if (urlParams.has('status') && urlParams.has('group')) {
            this.state = {
                ...loadedState,
                listCLDefaultFilters: [
                    {
                        id: 'STATUS',
                        value: urlParams.get('status') ? urlParams.get('status') : '',
                    },
                    {
                        id: 'GROUP',
                        value: urlParams.get('group').split(',')
                    }
                ]
            }
        } else if (urlParams.has('status') && !urlParams.has('group')) {
            this.state = {
                ...loadedState,
                listCLDefaultFilters: [
                    {
                        id: 'STATUS',
                        value: urlParams.get('status') ? urlParams.get('status') : '',
                    }
                ]
            }
        } else if (!urlParams.has('status') && urlParams.has('group')) {
            this.state = {
                ...loadedState,
                listCLDefaultFilters: [
                    {
                        id: 'GROUP',
                        value: urlParams.get('group').split(',')
                    }
                ]
            }
        } else {
            this.state = {
                ...loadedState,
                listCLDefaultFilters: loadedState.listCLDefaultFilters.filter(item => item.id !== 'GROUP')
            }
        }

        this.filtering = false;
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^listCL*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage = () => {
        for (let key in this.state) {
            if (this.state.hasOwnProperty(key) && key.match(/^listCL*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchClaimsListPageData(state.pageSize, state.sorted, state.cursor, state.isNextFromPivot, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            listCLDefaultPageSize: state.pageSize,
            listCLDefaultSort: state.sorted,
            listCLDefaultFilters: state.filtered
        });
    };

    fetchStrategy = state => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date || filterItem.id === 'ORDER_CREATION_TIME') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10)
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {columns, data, pages, isLoading, handleEditClick, isNextPage, isNextFromPivot} = this.props;
        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'TICKET_NUMBER',
                                    accessor: 'ticketNumber',
                                    message: listMessages.TABLE_TICKET_NUMBER,
                                    Cell: row => <Link to={`view/${row.original.id}`}>{row.value}</Link>
                                },
                                ...columns]}
                            toolButtons={[
                                {
                                    handleClick: handleEditClick,
                                    component: <PrimaryIcon className="btn btn-sm"
                                                            title="Edit"
                                                            type="button"
                                                            key="editButton">
                                        <IconEdit/>
                                    </PrimaryIcon>
                                }
                            ]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={this.state.listCLDefaultFilters}
                            defaultSorting={this.state.listCLDefaultSort}
                            defaultPageSize={this.state.listCLDefaultPageSize}
                            buttonVisibility={editClaimsListButtonVisibility[moduleRoles.isDealerClaims(this.props.userRoles) ? 'DEALER' : 'EDITOR']}
                            toolSortable={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

ListClaimsTable.propTypes = {
    handleEditClick: PropTypes.func.isRequired,
    columns: PropTypes.array,
    location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.claimsListPage.isTableLoading,
    data: state.claimsListPage.listData,
    isNextPage: state.claimsListPage.isNextPage,
    isNextFromPivot: state.claimsListPage.isNextFromPivot,
    pages: state.claimsListPage.pages,
    userRoles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {
    fetchClaimsListPageData
})(ListClaimsTable);
